<template>
  <div class="hello">
    <TopBar />
    <div class="content">
      <div class="xiugaiTuImg apkSystime" @click="goToList">
        <div
          style="
            height: 80%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          "
        >
          <img src="../assets/apk.svg" style="height: 65%" alt="" />
        </div>
        <div style="width: 100%; text-align: center; cursor: pointer">
          APK版本管理
        </div>
      </div>
      <div class="xiugaiTuImg apkSystime-Two">
        <div
          style="
            height: 80%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          "
        >
          <img src="../assets/二维码.svg" style="height: 65%" alt="" />
        </div>
        <div style="width: 100%; text-align: center; cursor: pointer">
          高德位置二维码管理
        </div>
      </div>
      <div
        class="xiugaiTuImg apkSystime-Two"
        style="background-color: #a24d"
        @click="goToAPI"
      >
        <div
          style="
            height: 80%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          "
        >
          <img src="../assets/API监控.svg" style="height: 65%" alt="" />
        </div>
        <div style="width: 100%; text-align: center; cursor: pointer">
          API监控
        </div>
      </div>
      <div
        class="xiugaiTuImg apkSystime-Two"
        style="background-color: #a4d"
        @click="goToAppMonitor"
      >
        <div
          style="
            height: 80%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          "
        >
          <img src="../assets/computer.svg" style="height: 65%" alt="" />
        </div>
        <div style="width: 100%; text-align: center; cursor: pointer">
          APP监控
        </div>
      </div>
      <div
        class="xiugaiTuImg apkSystime-Two"
        style="background-color: #ffc400"
        @click="goToFileServer"
      >
        <div
          style="
            height: 80%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          "
        >
          <img src="../assets/文件服务器.svg" style="height: 65%" alt="" />
        </div>
        <div style="width: 100%; text-align: center; cursor: pointer">
          文件服务器
        </div>
      </div>
      <div
        class="xiugaiTuImg apkSystime-Two"
        style="background-color: #26c6da"
        @click="goToDataInteraction"
      >
        <div
          style="
            height: 80%;
            width: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
          "
        >
          <img src="../assets/接口监控.svg" style="height: 65%" alt="" />
        </div>
        <div style="width: 100%; text-align: center; cursor: pointer">
          数据交互
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopBar from "./Top.vue";
import { loginApi } from "../api/login";

export default {
  name: "HelloWorld",
  components: {
    TopBar,
  },
  data() {
    return {
      currentDomain: "",
    };
  },
  methods: {
    getFileServer() {
      loginApi.getCurrentDomain().then((response) => {
        console.log(response, "fdsjifdjisfjisd777jfisd");
        this.currentDomain = response.data.fileUrlUnlogin || "";
      });
    },
    goToList() {
      this.$router.push("/apk-list");
    },
    goToAPI() {
      window.open("http://8.133.18.74:3000/public-dashboards/9487465fd0c14d298935746133f18c4a");
    },
    goToAppMonitor() {
      this.$router.push("/app-monitor");
    },
    goToFileServer() {
      window.open(`http://${this.currentDomain}`);
    },
    goToDataInteraction() {
      this.$router.push("/data-interaction");
    },
  },
  mounted() {
    this.getFileServer();
  },
};
</script>

<style scoped lang="less">
.hello {
  padding-top: 80px;
  background-color: #0052cd;
}

.content {
  width: 100%;
  height: calc(100vh - 60px);
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 20px;
  padding: 20px;
  box-sizing: border-box;
  .xiugaiTuImg {
    width: 280px;
    height: 180px;
    background-color: aquamarine;
    margin: 0;

    &.apkSystime {
      background-color: #de868f;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      border-radius: 10px;
      position: relative;
    }
    &.apkSystime-Two {
      background-color: #a2ef4d;
      font-size: 18px;
      font-weight: bold;
      color: #fff;
      border-radius: 10px;
      position: relative;
    }
  }
}
</style>
